<template>
  <div v-if="showModel"
       class="caiyunicon-model point"
       id="point"
       @click="hide($event)">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{$t('points.details')}}</span>
        <div class="point-help">
          <img src="../assets/about-point.png" alt="">
          <div class="potin-content">
            <h6>{{$t('points.what')}}</h6>
            <div>{{$t('points.isWhat')}}</div>
            <h6>{{$t('points.computations')}}</h6>
            <ul :class="['point-list', 'en-point-list',{'isEngCss':isChinese}]">
              <li v-for="(item,index) in pointList" class="clearfix" :key="index">
                <div>{{item.title}}</div>
                <div :class="[{ 'red': item.point<0 }]">{{item.point>0?'+'+item.point:item.point}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box-list">
        <div v-for="(o,index) in iconList"
             :key="index" class="text point_item">
          <div class="point_title">{{o.action}}</div>
          <div class="point_time">{{o.created_at}}</div>
          <div class="point_point">{{o.point_effect}}</div>
        </div>
        <div class="add-more"
             v-if="iconList.length>0 && addFlag"
             @click="addMore">{{$t('points.add')}}</div>
      </div>
    </el-card>
  </div>
</template>
<style  scoped>
  >>>.el-card{
    overflow: inherit;
  }
  >>>.el-card__header{
       position: relative;
       color: #5EBB8D;
       font-weight:800;
  }
  >>>.el-card__body{
    padding:0;
  }
  .caiyunicon-model.point{
    position: fixed;
    left:0;
    top:0;
    bottom:0;
    right:0;
    z-index:1000;
    background: rgba(0,0,0,0.4);
  }
  .box-list{
    overflow-y: scroll;
    height: 420px;
    padding-left: 20px;
    padding-right: 25px;
    padding-top: 15px;
  }
  .point .box-card{
    width: 400px;
    height: 500px;
    padding-bottom: 10px;
    left:50%;
    top:50%;
    position: absolute;
    transform: translate(-50%,-50%);
  }
  .point_item{
    position: relative;
    height: 30px;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }
  .box-list .point_item:last-child{
    border-bottom: none;
  }
  .point_item>div{
    position: absolute;
  }
  .point_title{
    left:0;
    top:0;
    font-size: 14px;
  }
  .point_time{
    left:0;
    top:18px;
    color: #9fa1a0;
    font-size: 12px;
  }
  .point_point{
    right:0;
    top:0;
    font-size: 14px;
  }
  .point .add-more{
    text-align: center;
    color: #ccc;
    font-size:12px;
    cursor: pointer;
  }
  .point-help{
    position: absolute;
    right:10px;
    top:50%;
    transform: translateY(-50%);
  }
  .potin-content{
    position: absolute;
    right: -280px;
    top: -12.5px;
    width: 220px;
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    display: none;
  }
  .point-help:hover .potin-content{
    display: block;
  }
  .point-help >img{
     display: block;
      width:30px;
      cursor: help;
   }
  .potin-content >h6{
    margin: 0;
    font-size: 16px;
    color: #5EBB8D;
    height:30px;
    line-height: 30px;
  }
  .point-list{

  }
  .point-list>li{
    height:30px;
    line-height:30px;
    font-size: 12px;
    border-left:1px solid #35806587;
    border-right:1px solid #35806587;
    border-top:1px solid #35806587;
  }
  .point-list>li:last-child{
    border-bottom:1px solid #35806587;
  }
  .point-list>li:nth-child(n){
    background: #93e2c687;
  }
  .point-list>li:nth-child(2n-1){
    background: #fff;
  }
  .point-list>li>div{
    float: left;
    box-sizing: border-box;
  }
  .point-list>li>div:first-child{
    width:75%;
    text-indent: 10px;
  }
  .point-list>li>div:last-child{
    text-align: center;
    color: #5EBB8D;
    width:25%;
    border-left:1px solid #35806587;
  }
  .point-list>li>div:last-child.red{
    color: #FF3E5E;
  }
  @media (max-width:650px){
    .point .box-card{
       width: auto;
      left: 20px;
      right: 20px;
      top: 110px;
      bottom: 20px;
      transform: translate(0,0);
    }
    .point-help >img {
      display: none;
    }
  }

</style>
<script>
  import {getUserPoint,USER_INFO} from  '@/api/user'
  import {formatTime ,whatLang} from '@/utils/index'
  import {POINT,POINT_ICON} from '@/config/point-change';
  export default {
    name: "IconModel",
    data() {
      return {
        user:'',
        page:1,
        iconList:[],
        showModel:false,
        userId:'',
        addFlag:true,
        pointList:[],
        isChinese: whatLang() !='zh',
      };
    },
    mounted (){

    },
    created(){
      this.user = USER_INFO();
      for( let key in POINT){
        if (POINT_ICON[key]) {
          this.pointList.push({
            'title':POINT[key],
            'point':POINT_ICON[key]-0
          })
        }
      }
    },
    methods: {
      hide:function (e) {
          if(e.target.id === 'point'){
              this.showModel = false;
          }
      },
      show: function(id) {
        if(this.page>1 && this.userId == id){
          this.showModel = true;
            return ;
        }
        this.userId = id;
        this.showModel = true;
        this.page = 1;
        this.iconList=[];
        this.getIconList(this.page);
      },
      getIconList:function (page) {
        getUserPoint(this.userId,page).then(res=>{
          if(res.rc===0 ){
            const point = res.point || [];
            if(point.length > 0){
              for(let i = 0 ; i < point.length ;i++){
                point[i].created_at = formatTime(point[i].created_at);
                point[i].action = POINT[point[i].action] || '其他';
              }
              this.iconList = this.iconList.concat(point);
            }else{
              this.addFlag = false;
            }
          }
        })
      },
      addMore:function () {
        this.page++;
        this.getIconList(this.page);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/IconModel.vue